import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcorporatecabservice() {



  const cardData =
  {
    keyword: ' Pune Airport Corporate Cab Service',
    heading: 'Pune Corporate Cars India Private Limited: Pune Airport Corporate Cab Service',
    headingDescription: 'Pune Corporate Cars India Private Limited provides reliable and professional Pune Airport Corporate Cab Service, ensuring smooth and timely transportation for employees, business delegates, and top-level executives. Our fleet of premium sedans, SUVs, and luxury vehicles guarantees a comfortable and stress-free airport commute, whether for arrivals or departures. With trained chauffeurs, flight-time coordination, and round-the-clock availability, we deliver punctual, safe, and hassle-free airport travel solutions. Pune Corporate Cars India Private Limited ensures a seamless transportation experience for corporate travelers operating in and around Pune.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],


"services": [
  {
    "name": "Airport Pickup Drop Pune Corporate",
    "description": "Airport Pickup Drop Pune Corporate provides reliable and punctual pickup–drop services for executives and teams traveling to and from Pune Airport. With clean vehicles and trained chauffeurs, the service ensures smooth and timely airport transfers."
  },
  {
    "name": "Airport Employee Shuttle Pune",
    "description": "Airport Employee Shuttle Pune offers structured shuttle services for staff commuting between the airport and corporate offices. Ideal for multi-shift travel, the service ensures safe, coordinated, and efficient employee movement."
  },
  {
    "name": "Corporate Airport Taxi Pune",
    "description": "Corporate Airport Taxi Pune delivers professional and comfortable taxi services for business travelers. With sedans and SUVs operated by trained drivers, the service ensures seamless transportation for arrivals, departures, and business schedules."
  },
  {
    "name": "Airport Chauffeur Pune",
    "description": "Airport Chauffeur Pune offers premium chauffeur-driven cars for airport transfers. Ideal for executives and VIP guests, this service provides professional drivers, comfortable vehicles, and smooth corporate travel experiences."
  },
  {
    "name": "Airport Business Cab Hire Pune",
    "description": "Airport Business Cab Hire Pune provides business-class cab services designed for corporate travel requirements. With clean vehicles and timely operations, the service ensures stress-free and comfortable airport journeys."
  },
  {
    "name": "Pune Airport Fleet Provider",
    "description": "Pune Airport Fleet Provider supplies dedicated fleets of sedans, SUVs, and corporate cabs for airport travel. Ideal for companies handling frequent airport movement, the service provides consistent availability and professional operation."
  },
  {
    "name": "Corporate Airport Transfer Pune",
    "description": "Corporate Airport Transfer Pune offers end-to-end transportation solutions for executives, employees, and clients needing smooth airport connections. The service ensures punctual pickups, GPS-enabled tracking, and comfortable travel."
  },
  {
    "name": "Airport Sedan Cab Pune",
    "description": "Airport Sedan Cab Pune delivers premium sedan-based travel for airport pickup and drop. Ideal for business travelers, the service ensures comfort, professionalism, and timely coordination across Pune."
  },
  {
    "name": "Airport SUV Cab Pune",
    "description": "Airport SUV Cab Pune provides spacious and comfortable SUVs for corporate airport travel. Suited for executives, teams, or luggage-heavy journeys, the service ensures a premium and reliable ride experience."
  },
  {
    "name": "Airport Shuttle for Companies Pune",
    "description": "Airport Shuttle for Companies Pune offers high-capacity shuttle vans and minibuses for employee and team movement to and from Pune Airport. Ideal for flight-based shift changes and group travel."
  },
  {
    "name": "Best Corporate Airport Cabs Pune",
    "description": "Best Corporate Airport Cabs Pune provides top-quality sedans and SUVs with professional chauffeurs, ensuring safe, punctual, and comfortable airport travel for business needs."
  },
  {
    "name": "Airport Office Staff Transport Pune",
    "description": "Airport Office Staff Transport Pune delivers structured transport solutions for office staff traveling from the airport to workplaces across Pune. The service ensures reliable, well-coordinated, and timely staff movement."
  },
  {
    "name": "Premium Airport Cab Pune",
    "description": "Premium Airport Cab Pune offers high-end cabs with trained chauffeurs for executive and VIP airport transfers. The service ensures luxurious comfort and smooth travel for business journeys."
  },
  {
    "name": "Airport Travel Management Pune",
    "description": "Airport Travel Management Pune provides complete airport mobility planning for companies, including scheduling, tracking, and fleet coordination. Ideal for large teams and frequent business flyers."
  },
  {
    "name": "Executive Airport Taxi Pune",
    "description": "Executive Airport Taxi Pune delivers comfortable, clean, and professionally driven taxis designed for executive-level airport transportation. The service ensures timely travel and a premium ride experience."
  }
],

"tableData": [
  ["Airport Pickup Drop Pune Corporate", "Airport Employee Shuttle Pune"],
  ["Corporate Airport Taxi Pune", "Airport Chauffeur Pune"],
  ["Airport Business Cab Hire Pune", "Pune Airport Fleet Provider"],
  ["Corporate Airport Transfer Pune", "Airport Sedan Cab Pune"],
  ["Airport SUV Cab Pune", "Airport Shuttle for Companies Pune"],
  ["Best Corporate Airport Cabs Pune", "Airport Office Staff Transport Pune"],
  ["Premium Airport Cab Pune", "Airport Travel Management Pune"],
  ["Executive Airport Taxi Pune", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Pune Airport Corporate Cab Service",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable and comfortable airport cab services for corporate clients, ensuring timely pickups and drop-offs for business travelers."
  },
  {
    "WhyChooseheading": "Punctual & Hassle-Free Airport Transfers",
    "WhyChoosedescription": "We guarantee on-time pickups and seamless airport transfers, so executives and employees reach their flights without stress or delay."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs for Corporate Travel",
    "WhyChoosedescription": "Our trained and courteous drivers provide safe, professional, and efficient airport transportation, maintaining high standards of service."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Need",
    "WhyChoosedescription": "Choose from sedans, SUVs, and luxury vehicles for your airport trips, all maintained for comfort, safety, and reliability."
  },
  {
    "WhyChooseheading": "Flexible & Customized Booking",
    "WhyChoosedescription": "We offer flexible cab rental options for corporate schedules, including hourly, one-way, and round-trip packages to suit business requirements."
  },
  {
    "WhyChooseheading": "24/7 Airport Cab Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for flight delays, rescheduling, and last-minute bookings, ensuring smooth corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Sanitized Vehicles",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, ensuring a safe and comfortable journey for your team."
  },
  {
    "WhyChooseheading": "Efficient Coordination for Corporate Travel",
    "WhyChoosedescription": "We manage airport logistics efficiently, allowing businesses to focus on their work while we handle timely and reliable transportation."
  }
]



























  }

const faqData = [
  {
    question: 'Do you provide Pune Airport corporate cab services?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and punctual corporate cab services for airport pickups and drops.',
  },
  {
    question: 'Are the airport corporate cabs available 24×7?',
    answer: 'Yes, our airport transfer services operate round the clock to support early-morning and late-night corporate travel.',
  },
  {
    question: 'How can companies book Pune Airport corporate cab services?',
    answer: 'Corporate clients can book through our website, mobile app, or dedicated 24×7 corporate support team.',
  },
  {
    question: 'Do you track flight schedules for timely airport pickups?',
    answer: 'Yes, we monitor flight timings to ensure timely pickups and avoid delays for corporate travelers.',
  },
  {
    question: 'What types of vehicles are available for airport corporate cab service?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, and Innova Crysta for executive airport travel.',
  },
  {
    question: 'Do you provide corporate invoicing for airport cab bookings?',
    answer: 'Yes, we offer monthly corporate invoicing, GST billing, and digital payment options.',
  },
  {
    question: 'Are chauffeurs trained for airport transfer protocols?',
    answer: 'Yes, our drivers are trained in airport procedures, punctuality, and professional corporate etiquette.',
  },
  {
    question: 'What safety measures are in place for airport corporate cab services?',
    answer: 'All vehicles are sanitized regularly, GPS-enabled, and driven by experienced and verified chauffeurs.',
  },
  {
    question: 'Can companies schedule recurring airport transfers for employees?',
    answer: 'Absolutely. We offer recurring bookings and bulk travel plans for frequent airport commuters.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'The Pune Airport corporate cab service was extremely punctual and professional. Excellent service for our business travelers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rhea Chavan',
    feedback: 'We rely on Pune Corporate Cars India Private Limited for all our airport transfers. Seamless booking and very dependable drivers.',
    rating: 5,
  },
];



















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Corporate Cab Service",
  "image": "https://www.punecorporatecars.com/assets/images/pune-airport-corporate-cab.jpg", // replace with actual image URL
  "description": "Pune Corporate Cars India Private Limited offers professional corporate cab services for airport transfers in Pune, including employee pick-up and drop, chauffeur-driven sedans and SUVs, and business travel. Reliable, safe, and timely corporate airport cabs for companies and IT parks.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",  // update if needed
    "ratingCount": "4800", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/pune-airport-corporate-cab-service"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune Airport Corporate Cab Service | Employee & Business Airport Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Pune Corporate Cars India Private Limited offers professional corporate cab services for airport transfers in Pune, including employee pick-up and drop, chauffeur-driven sedans and SUVs, and business travel. Reliable, safe, and timely corporate airport cabs for companies and IT parks."
  />

  <meta
    name="keywords"
    content="Airport Pickup Drop Pune Corporate, Airport Employee Shuttle Pune, Corporate Airport Taxi Pune, Airport Chauffeur Pune, Airport Business Cab Hire Pune, Pune Airport Fleet Provider, Corporate Airport Transfer Pune, Airport Sedan Cab Pune, Airport SUV Cab Pune, Airport Shuttle for Companies Pune, Best Corporate Airport Cabs Pune, Airport Office Staff Transport Pune, Premium Airport Cab Pune, Airport Travel Management Pune, Executive Airport Taxi Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportcorporatecabservice;